module.exports = __webpack_public_path__ + "static/img/ship-cruiser_256.9686509.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ship-cruiser_256.png
// module id = 1Q+t
// module chunks = 0